import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalUnitSearchModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_GET_DASH_RECENT_CANCELLED_LIST = (take?: number) => ['getDashRecentPendingCancelList', take].filter(Boolean)

export const getDashRecentCancelledList = async (take: number): Promise<IPortalUnitSearchModel[]> =>
  axios.get(`/dashwidget/getrecentcancelledunitlist?take=${take}`).then((res) => res.data?.data)

type QueryFnType = typeof getDashRecentCancelledList

type Props = {
  config?: QueryConfig<QueryFnType>
  take: number
}

export const useGetDashRecentCancelledList = ({ config, take }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: QUERY_KEY_GET_DASH_RECENT_CANCELLED_LIST(take),
    queryFn: () => getDashRecentCancelledList(take)
  })
